import { Flex, Typography } from 'antd'

interface StepHeaderProps {
  title: string
  /** Sarlavhani ochib beruvchi bir qator — bo'lmasa qadam faqat sarlavha bilan qoladi */
  subtitle?: string
}

/**
 * Qadam sarlavhasi — mehmon tizimni BILMAYDI va yordam so'raydigan odami
 * yo'q, shuning uchun har ekran o'zi nima ekanini O'ZI aytadi.
 *
 * ⚠️ Ilgari har qadamda ekrandagi yagona tushuntirish kichik, kulrang
 * `type="secondary"` qator edi: eng muhim ko'rsatma eng zaif uslubda
 * yozilgan, uning ustidagi sarlavha esa (uch tilda tayyor bo'lsa ham)
 * hech qayerdan chaqirilmagan. Bu yerda ikki vazn ajratilgan — sarlavha
 * nima so'ralayotganini, izoh esa nima bo'lishini aytadi.
 */
export function StepHeader({ title, subtitle }: StepHeaderProps) {
  return (
    <Flex vertical gap={4} style={{ textAlign: 'center' }}>
      <Typography.Title level={5} style={{ margin: 0 }}>
        {title}
      </Typography.Title>
      {subtitle ? <Typography.Text type="secondary">{subtitle}</Typography.Text> : null}
    </Flex>
  )
}
